import React, {Component} from 'react'
import styled from 'styled-components'
import LandingPg from './BusinessHomeViews/Computer/Landing/LandingPg';
import SignUp from './SignUp/Computer/Home/Business-Side/SignUpHome';
import UserLandingPg from './CustomerHomeViews/Computer/UserLandingPg'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import fire from './database/firebase';
import SmallPhoneRewards from './Components/Customer-Side/PageSections/Rewards/SmallPhone/RewardsSmPhone'
import SmallPhoneChallenges from './Components/Customer-Side/PageSections/Challenges/SmallPhone/ChallengesSmPhone'
import SmallPhoneSecretMenu from './Components/Customer-Side/PageSections/SecretMenu/SmallPhone/SecretMenuSmPhone'
import SmallPhoneWishList from './Components/Customer-Side/PageSections/WishList/SmallPhone/WishListSmPhone'
import SignUpCustomer from './SignUp/Computer/SignUpPage/Customer-Side/SignUpCustomer';
import { Last } from 'react-bootstrap/esm/PageItem';
import { useLocation } from 'react-router-dom';
import SignUpBusiness from './SignUp/Computer/SignUpPage/Business-Side/SignUpBusiness';


class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null,
      adminUser: null,
      adminAccess: []
    }
  }

  componentDidMount = () => {
    // const url = window.location.href
    // const parts = url.split('/'); // Split the URL by '/'
    // const secondPart = parts[parts.length - 2] // Get second last part (login/sign-up)
    // const lastPart = parts[parts.length - 1]; // Get the last part (restaurant name)
    // const location = useLocation();

  // Access the current URL from location.pathname
    // const currentURL = location.pathname;
    // console.log(currentURL)

    fire.firestore().collection("clients")
    .doc("artcaffe")
    .collection("adminAccess")
    .get().then(snapshot => {
      const data = snapshot.docs.map(doc => doc.data().email)
      this.authListener(data)
      this.setState({
        adminAccess: data
      })
    })
  }

  loadAdminEmails = (client) => {
    fire.firestore().collection("clients")
    .doc(window.location.href = ``)
  }

    //* - - HACKY SOLUTION - - *//

    /* 
      - Load all of the business emails that have access to the the business dashboard
      - IF email is in the array --> 
      - In authListener() --> check if the emails are accessible 
    */

  authListener = (adminAccess) => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({user})
        if (adminAccess.includes(user.email)) {
          this.setState({adminUser: true})
        }
      } else {
        console.log("We failed dawg")
        this.setState({user:null})
      }
    })
  }
 
  render () {
    return (
        <div className="App">
          {this.state.user === null && this.state.loading ? (
            // Display loading indicator while data is loading
          <div className="loading-screen">
            <p>Loading...</p>
          </div>
          ) : (
            // Render routes based on authentication status
            <Router>
              <Routes>
                {this.state.user ? (
                  this.state.adminUser ? (
                    <Route path="/dashboard" element={<LandingPg/>}/>
                  ) : (
                    <>
                      <Route path="/home/:link" element={<UserLandingPg />}/>
                      <Route path="/smp-rewards/:link" element={<SmallPhoneRewards />}/>
                      <Route path="/smp-challenges/:link" element={<SmallPhoneChallenges />}/>
                      <Route path="/smp-secret-menu/:link" element={<SmallPhoneSecretMenu />}/>
                      <Route path="/smp-wish-list/:link" element={<SmallPhoneWishList />}/>
                    </>
                  )
                ) : (
                  <>
                    <Route path="/" element={<SignUp />}/>
                    <Route path="/business/sign-up" element={<SignUpBusiness/>}/>
                    <Route path='/sign-up/:link' element={<SignUpCustomer/>}/>
                    <Route path='/login/:link' element={<SignUpCustomer/>}/>
                  </>
                )}
              </Routes>
            </Router>
          )}
        </div>
      );
  }
}
export default App;
